<template>
  <ValidationProvider name="cover" slim vid="cover">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="audience_cover"> Cover </BaseFormLabel>
        <div>
          <img v-if="value" :src="value.url" :alt="value.name" class="rounded-lg mb-2" />
          <BaseFormInput type="hidden" :value="coverId" />
          <BaseButton primary outline small type="button" @click="openMediaSelectDialong">
            {{ value ? 'Change' : 'Select' }} Cover
          </BaseButton>
        </div>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  computed: {
    coverId() {
      return this.value?.id || null;
    },
  },
  methods: {
    onSelect(media) {
      this.$emit('input', media);
    },
    openMediaSelectDialong() {
      this.$modal.show({
        component: () => import('Components/MediaLibrary/MediaSelectDialog.vue'),
        props: {
          mimeTypes: 'image/',
        },
        on: {
          select: this.onSelect,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
